export default __webpack_public_path__ + "static/media/get-instant.01cd678a.png";